export default {
  resourcesInCategory: 'Ressources dans cette catégorie',
  resourcesDescription: 'Parcourir toutes les ressources de cette catégorie'
};
